var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRewards = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z",
    transform: "matrix(-1 0 0 1 20 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.4286 13.5715c0-2.9925-2.4358-5.42862-5.4284-5.42862-2.99269 0-5.42848 2.43612-5.42848 5.42862 0 2.9924 2.43579 5.4285 5.42848 5.4285 2.9926 0 5.4284-2.4361 5.4284-5.4285z",
    stroke: "#15206b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#15206b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.85786 0c.2483 0 .47831.128827.60798.340136l1.53436 2.493624 1.5349-2.493624c.1297-.211309.3601-.340136.6084-.340136h3.1717l-3.6279 5.90136c-1.1773-.25893-2.28313-.2398-3.37409 0l-3.62705-5.90136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9778 0h2.3074c.2589 0 .4974.140306.6237.366071.1263.226191.1207.502126-.0153.722789l-4.295 6.97959c-.7126-.72491-1.5629-1.31292-2.5102-1.71939l3.8694-6.2942131c.0107-.0174319.0111-.0369898.02-.05442173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.0910664.366071c.1262726-.22619.3647866-.366071.6237106-.366071h2.307353c.00892.017432.00935.0369898.01998.0544218l3.86939 6.2942182c-.94683.40646-1.79716.99447-2.51015 1.71939l-4.294979-6.97959c-.1360513-.220243-.1415778-.496603-.0153046-.722794z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRewards);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rewards.8919600226968e5008ff7227605af164.svg";